import loadable from "@loadable/component";

export const UiMarketoForm = loadable(() => import("./UiMarketoForm"), {
    ssr: false
});
